import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { AuthService } from '../../../services/auth.service';
import { LocaleService } from '../../../services/locale.service';

@Component({
  selector: 'app-contribuente-pratiche',
  templateUrl: './contribuente-pratiche.component.html',
  styleUrls: ['./contribuente-pratiche.component.css']
})
export class ContribuentePraticheComponent implements OnInit {
	@Input() idPerson: any;
	@Input() writePermission: boolean = false;

	comune: any = {};
	comuneSync: Subscription;
	statesDict: any = null;
	statesDictSync: Subscription;
	pratiche: any[] = [];
	praticheTmp: any[] = [];
	loading: boolean = true;
	num_pratiche = 0;
	praticheDettagliSync: Subscription;
	pagamenti: any[] = [];
	pagamentiSync: Subscription;

	numPratica: any = 0;
	infoPratica: any = {};
	dettagliPratica: any[] = [];
	selectedRow: string = '';
	idSelected: string = '';

	parametri: any = {
		ricalcolaRettifica: false,
		ricalcolaSanzioni: false,
	};
	parametriString: string = '{}';

	modalInput: any = {
		size: '',
		title: '',
		subtitle: '',
		data: {
			id: 0,
			crc: 0,
			person: null,
			uid: null,
			id_prat: null,
			reset: false,
			readOnly: true,
		}
	};

	modalRettifica: any = {
		size: '',
		title: '',
		subtitle: '',
		data: {
			id: 0,
			crc: 0,
			person: null,
			uid: null,
			id_prat: null,
			reset: false,
			readOnly: true,
		}
	};

	datiRettifica: string = '';

	canForward: boolean = false;
	nextStep: any = {
		idStatoAttuale: '',
		idStato: '',
		nomeStato: '',
		codiceStato: '',
		uids: [],
		comuneId: '0',
		nomeComune: ''
	};

	constructor(
		private dataService: DataService,
		private authService: AuthService,
		private formatter: LocaleService
		) { }

	ngOnInit() {
		this.statesDictSync = this.dataService.statesDict$.subscribe(
			statesDict => {
				this.statesDict = statesDict;
			});
		this.comuneSync = this.dataService.getComuniService().comune$.subscribe(
			comune => {
				console.log('COMUNE',comune)
				if (comune) {
					this.comune = comune;
					this.nextStep.idComune = this.comune.id;
					this.nextStep.nomeComune = this.comune.nome;
				}
			});
		this.praticheDettagliSync = this.dataService.praticheDettagli$.subscribe(
			() => {
				this.loadFromDB(false);
			});
		this.pagamentiSync = this.dataService.pagamenti$.subscribe(
			pagamenti => {
				this.pagamenti = pagamenti;
				this.fillNumPratiche();
			});
	}

	ngOnChanges(changes: any){
		console.log('CHANGE CONTRIBUENTE PRATICHE', changes);
		if(this.statesDict && changes.idPerson){
			this.parametriString = JSON.stringify(this.parametri);
			this.loadFromDB(true);
		}
	}

	loadFromDB(changePerson: boolean){
		this.loading = true;
		if(this.idPerson){
			this.dataService.getPraticheByPersonId(this.idPerson, (pratiche) => {
				this.pratiche = pratiche;
				this.dettagliPratica = [];
				if(this.pratiche && this.pratiche.length){
					if(changePerson)
						this.numPratica = 0;
					this.infoPratica = this.pratiche[this.numPratica];
					this.idSelected = this.infoPratica.id_prat;
	 				this.getPraticaDettagli(this.infoPratica.id);
					this.fillNumPratiche();
	 			}
				console.debug('CONTRIB-PRATICHE| PRATICHE', this.pratiche);
			});
		}
		this.loading = false;
	}

	getPraticaDettagli(uid: any) {
		this.dataService.getDettagliByUid(uid, (localDettagli) => {
			this.dettagliPratica = localDettagli;
		});
		let selectedRow = {
			infoPratica: this.infoPratica,
			dettagliPratica: this.dettagliPratica
		}
		//console.debug('CONTRIB-PRATICHE| SELECTEDROW', uid, this.dettagliPratica, this.infoPratica, this.dettagliPratica);
		this.selectedRow = JSON.stringify(selectedRow);
	}

	onSelect(row: any){
		console.debug('CONTRIB-PRATICHE| ONSELECT', row);
		this.idSelected = row.id_prat;
		this.infoPratica = row;
		this.getPraticaDettagli(row.id)
	}

	fillNumPratiche(){
		this.num_pratiche = 0;
		for(let pratica of this.pratiche){
			this.num_pratiche++;
		}
	}

	aggiungiPratica() {
		this.dataService.getPersonById(this.idPerson, (person) => {
			this.modalInput = {
				size: 'large-modal',
				title: 'Aggiungi',
				subtitle: 'Nuova Pratica',
				data: {
					id: null,
					crc: Math.floor(Math.random() * 100),
					person: person,
					uid: null,
					id_prat: null,
					new_prat: true,
					reset: true,
					readOnly: false,
				}
			};
			this.modalInput.data = JSON.stringify(this.modalInput.data);
			//this.loadFromDB(false);
			console.debug("CONTRIB-PRATICHE| AGGIUNGIPRATICA", this.modalInput);
		});
	}

	modificaPratica() {
		this.modalInput = {
			size: 'large-modal',
			title: 'Modifica',
			subtitle: 'Pratica: ' + this.infoPratica.id_prat,
			data: {
				id: this.infoPratica.id,
				crc: Math.floor(Math.random() * 100),
				person: null,
				uid: Number(this.infoPratica.id),
				id_prat: this.infoPratica.id_prat,
				new_prat: false,
				rettifica: false,
				initial_state: this.infoPratica.stato_id == 1,
				reset: true,
				readOnly: false,
			}
		};
		this.modalInput.data = JSON.stringify(this.modalInput.data);
		//this.loadFromDB(false);
		console.debug("CONTRIB-PRATICHE| MODIFICAPRATICA", this.modalInput, this.infoPratica);
	}

	preparaAtti() {
		this.modalInput = {
			size: 'large-modal',
			title: 'Atti',
			subtitle: 'Pratica: ' + this.infoPratica.id_prat,
			data: this.infoPratica,
		};
	}

	eliminaPratica() {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: this.infoPratica.id });

		let titleConfirm = "Richiesta conferma";
		let confirmContent = "Vuoi veramente eliminare la pratica n°"+this.infoPratica.id_prat+"?";
		this.dataService.openConfirm(titleConfirm, confirmContent, () => {
			console.log("eliminaPratica", this.infoPratica.id_prat);
			this.dataService.delete("pratiche", localFilters, true, (error,res) => {
				if(error){
					//this.dataService.openMessage('ELIMINAZIONE PRATICA','si è verificato un errore');
				}
				if(res){
					console.log("ELIMINAZIONE PRATICA", res);
				}
			});
			this.loadFromDB(false);
		});
	}

	apriNotifica(){
		this.dataService.getAttiByUid(this.infoPratica.id, (atti) => {
			let atto: any = {
				id: this.infoPratica.id,
				uid: Number(this.infoPratica.id),
				id_prat: this.infoPratica.id_prat,
				dataNotifica: null,
				indiceNotifica: null,
				tipoNotifica: null,
			};
			if(atti.length)
				atto = atti[0];

			this.modalInput = {
				size: 'large-modal',
				title: 'Immissione Manuale Notifica',
				subtitle: 'Pratica: ' + this.infoPratica.id_prat,
				data: {
					id: this.infoPratica.id,
					crc: 0,
					uid: Number(this.infoPratica.id),
					id_prat: this.infoPratica.id_prat,
					dataNotifica: atto.notifica_data,
					indiceNotifica: atto.notifica_indice,
					tipoNotifica: atto.notifica_tipo,
					reset: false,
					readOnly: false,
				}
			};
			console.log("apriNotifica", this.modalInput, atto, atti);
		});
	}

	apriPagamenti(){
		this.modalInput = {
			size: 'large-modal',
			title: 'Immissione Manuale Pagamenti',
			subtitle: 'Pratica: ' + this.infoPratica.id_prat,
			data: this.infoPratica
		};
	}

	getInnerEvents(event: any) {
		let localComuneId = true;
		let localFilters: any = [];
		let localSets: any = {};
		console.log('PRATICHE PAYMENTS INNER EVENT',event);
		if(event.aggiungiPagamento){
			localFilters.push({ "uid": event.uid });
			localSets = event.setValue;
			this.dataService.insertPagamento(event.uid, event.setValue,true,(err,data) => {
				if (err) {
					console.log('insertPagamento|error',err);
				}else {
					console.log('insertPagamento|success', data, localFilters)
				}
			});
		}
	}

	apriCambiaStato(){
		this.modalInput = {
			size: 'little-modal',
			title: 'Cambia Stato',
			subtitle: 'Pratica: ' + this.infoPratica.id_prat,
			data: {
				id: this.infoPratica.id,
				crc: 0,
				uid: Number(this.infoPratica.id),
				id_prat: this.infoPratica.id_prat,
				reset: false,
				readOnly: false,
			}
		};
	}

	apriCronologiaPratica(){
		this.modalInput = {
			size: 'large-modal',
			title: 'Cronologia',
			subtitle: 'Pratica: ' + this.infoPratica.id_prat,
			data: {
				id: this.infoPratica.id,
				crc: 0,
				uid: Number(this.infoPratica.id),
				id_prat: this.infoPratica.id_prat,
				reset: false,
				readOnly: true,
			}
		};
	}

	preparaRettifica(event) {
		console.log('PREPARA RETTIFICA');
		this.modalRettifica = {
			size: 'large-modal',
			title: 'Rettifica',
			subtitle: 'Pratica: ' + this.infoPratica.id_prat,
			data: {
				id: this.infoPratica.id,
				crc: Math.floor(Math.random() * 100),
				person: null,
				uid: Number(this.infoPratica.id),
				id_prat: this.infoPratica.id_prat,
				new_prat: false,
				rettifica: true,
				initial_state: this.infoPratica.stato_id == 1,
				reset: true,
				readOnly: false,
			},
		};
		if (event.rev) {
			console.log('PREPARA RETTIFICA REV');
			this.modalRettifica.data['rev'] = event.rev;
			this.modalRettifica.data['praticaRet'] = event.data.pratica;
			this.modalRettifica.data['dettagliRet'] = event.data.dettagli;
		}
		this.modalRettifica.data = JSON.stringify(this.modalRettifica.data);
	}

	getRettificata(event:any) {
		console.log('PRATICA RETTIFICATA pre');
		let rettifica = {};
		rettifica['pratica'] = event.selectedRow.infoPratica;
		rettifica['dettagli'] = event.selectedRow.dettagliPratica;
		this.datiRettifica = JSON.stringify(rettifica);
		console.log('PRATICA RETTIFICATA post',this.datiRettifica);
	}

	avanzaPratiche() {
		this.nextStep.preselected = [];
		this.nextStep.idStatoAttuale = this.infoPratica.stato_id;
		this.nextStep.comuneId = this.dataService.getComuniService().getComuneId();
		this.nextStep.codiceComune = this.dataService.getComuniService().getComuneCodice();
		this.nextStep.nomeComune = this.comune.nome;
		this.nextStep.uids = [];
		this.nextStep.uids.push(this.infoPratica.id);
		this.nextStep.primoAtto = this.infoPratica.id;
		this.nextStep.ultimoAtto = this.infoPratica.id;
		this.modalInput = {
			size: 'medium-modal',
			title: 'Avanza Pratica',
			subtitle: 'Pratica: ' + this.infoPratica.id_prat,
			data: this.nextStep
		};
		// this.loadFromDB(false);
	}

	ngOnDestroy() {
		if(this.statesDictSync){
			this.statesDictSync.unsubscribe();
		}
		if(this.comuneSync){
			this.comuneSync.unsubscribe();
		}
		if(this.praticheDettagliSync){
			this.praticheDettagliSync.unsubscribe();
		}
		if(this.pagamentiSync){
			this.pagamentiSync.unsubscribe();
		}
	}
}
